import React from "react";
import { useProjectData } from "../../projects/ProjectDataContext";
import { useProjects } from "../../auth/ProjectContext";

const columns = ["To Do", "In Progress", "Done"] as const;

export default function KanbanBoardView() {
  const { currentProject } = useProjects();
  const { projects, updateTask } = useProjectData();
  const project = projects.find((p) => p.id === currentProject?.id);

  const handleDrop = (e: React.DragEvent<HTMLDivElement>, status: string) => {
    const id = e.dataTransfer.getData("text/plain");
    if (!project) return;
    updateTask(project.id, id, { status });
  };

  return (
    <div style={{ display: "flex", gap: "1rem", padding: "1rem" }}>
      {columns.map((col) => (
        <div
          key={col}
          onDragOver={(e) => e.preventDefault()}
          onDrop={(e) => handleDrop(e, col)}
          style={{ flex: 1, background: "#f5f5f5", padding: "0.5rem", borderRadius: 4 }}
        >
          <h4>{col}</h4>
          {project?.tasks
            .filter((t) => (t.status || "To Do") === col)
            .map((t) => (
              <div
                key={t.id}
                draggable
                onDragStart={(e) => e.dataTransfer.setData("text/plain", t.id)}
                style={{ background: "#fff", marginBottom: 4, padding: 4, border: "1px solid #ccc" }}
              >
                {t.name}
              </div>
            ))}
        </div>
      ))}
    </div>
  );
}
